/* Design System tokens — synced from Figma "Dosen 3.0" (nodes 2078:5588 + 3421:9222).
   Mirrors `tokens.css` so consumers can reference values from TS. */

export const colors = {
  brand: {
    orange500: '#f79420',
    orange700: '#f15a26',
    purple700: '#8e44ff',
    yellow700: '#f0b80d'
  },
  text: {
    primary: '#fdfdfd',
    secondary: '#b6b6b6',
    tertiary: '#868686'
  },
  stroke: {
    solidWhite: '#fdfdfd',
    solidBlack: '#0f0f0f',
    iconHighlight: '#fdfdfd',
    iconDim: '#868686',
    highlight: '#f79420',
    accent: '#f79420',
    divider: '#444444',
    borderDim: '#2a2a2a',
    formInputBorderDim: '#2a2a2a'
  },
  card: {
    fillDefault: '#151515',
    strokeHighlight: '#fdfdfd'
  },
  table: {
    fillHighlight: '#151515',
    strokePrimary: '#2a2a2a'
  },
  ui: {
    success: '#00972d',
    error: '#ff0000'
  },
  transparent: {
    transContrast2: 'rgba(255, 255, 255, 0.2)',
    transNormal9: 'rgba(0, 0, 0, 0.9)'
  },
  button: {
    cta: {
      fillDisabled: 'rgba(0, 0, 0, 0.2)',
      strokeDefault: '#fdfdfd',
      strokeOutline: '#fdfdfd',
      strokeDisabled: '#565656',
      strokeDisabledBorder: '#2a2a2a'
    },
    basic: {
      fillDefault: '#1c1c1c',
      fillDisabled: 'rgba(0, 0, 0, 0.2)',
      strokeDefault: '#fdfdfd',
      strokeDisabled: '#565656'
    },
    options: {
      fillDefault: '#565656',
      fillHover: '#868686',
      fillDisabled: 'rgba(0, 0, 0, 0.1)',
      strokeDefault: '#fdfdfd',
      strokeBorder: '#0f0f0f',
      strokeDisabled: '#565656'
    }
  }
} as const;

export const gradients = {
  cta: `linear-gradient(180deg, ${colors.brand.orange500} 0%, ${colors.brand.orange700} 100%)`
} as const;

export const shadows = {
  ctaHover: `0px 0px 7.5px ${colors.transparent.transContrast2}`,
  cardSelected: `0px 0px 25px ${colors.transparent.transNormal9}`
} as const;

/** Color used by the program-type selection tag in admin program cards. */
export const programTypeColors: Record<string, { background: string; foreground: string }> = {
  Mentorship: { background: colors.brand.purple700, foreground: colors.text.primary },
  Course: { background: colors.brand.yellow700, foreground: colors.stroke.solidBlack },
  'Guided Course': { background: colors.brand.orange700, foreground: colors.text.primary }
};
